import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useDealership } from '../../contexts/DealershipContext';
import OrdersList from '../../components/OrdersList';
import Pagination from '../../components/Pagination';
import UserContext from '../../contexts/UserContext';
import './OrdersPage.css';

const OrdersPage = () => {
  const {
    dealership,
    loading: dealershipLoading,
    ordersLoading,
    dealershipFetchAttempted,
    fetchDealership,
  } = useDealership();
  const { user } = useContext(UserContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filter, setFilter] = useState('Most Recent Order'); // State for filter dropdown

  useEffect(() => {
      if (!user) {
      return;
    }
    if (!dealership && !dealershipFetchAttempted) {
      fetchDealership();
    }
  }, [dealership, dealershipFetchAttempted, fetchDealership, user]);
  // Sorting logic based on filter selection
  const sortedOrders = useMemo(() => {
    if (!dealership?.orders) return [];

    const ordersCopy = [...dealership.orders];
    switch (filter) {
      case 'Most Recent Order':
        return ordersCopy.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      case 'Oldest Order':
        return ordersCopy.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      case 'Highest Value':
        return ordersCopy.sort((a, b) => b.orderTotal - a.orderTotal);
      case 'Lowest Value':
        return ordersCopy.sort((a, b) => a.orderTotal - b.orderTotal);
      default:
        return ordersCopy;
    }
  }, [filter, dealership?.orders]);

  const indexOfLastOrder = currentPage * itemsPerPage;
  const indexOfFirstOrder = indexOfLastOrder - itemsPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (number) => {
    setItemsPerPage(number);
    setCurrentPage(1);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setCurrentPage(1); // Reset pagination on filter change
  };
    if (!user) {
    return (
      <div className="orders-page">
        <div className="orders-header">
          <h1>My Orders</h1>
        </div>
        <div className="no-dealership">
          <p>Please log in to see this.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-page">
      <div className="orders-header">
        <h1>My Orders</h1>
      </div>

      {sortedOrders.length > 0 && (
        <>
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={sortedOrders.length}
            paginate={paginate}
            currentPage={currentPage}
            itemsPerPageOptions={[5, 10, 20, 50]}
            handleItemsPerPageChange={handleItemsPerPageChange}
          />

          <br />

          <div className="filter-dropdown">
            <select
              value={filter}
              onChange={handleFilterChange}
              className="order-filter"
            >
              <option value="Most Recent Order">Most Recent Order</option>
              <option value="Oldest Order">Oldest Order</option>
              <option value="Highest Value">Highest Value</option>
              <option value="Lowest Value">Lowest Value</option>
            </select>
          </div>
        </>
      )}

      {dealershipLoading || ordersLoading ? (
        <div className="loading">Loading orders...</div>
      ) : dealership ? (
        sortedOrders.length > 0 ? (
          <OrdersList orders={currentOrders} />
        ) : (
          <div className="no-orders">
            <p>No orders found for this dealership.</p>
          </div>
        )
      ) : (
        <div className="no-dealership">
          <p>No dealership information available.</p>
        </div>
      )}
    </div>
  );
};

export default OrdersPage;
